import { render, staticRenderFns } from "./PlatformAgreement.vue?vue&type=template&id=4525cd70&scoped=true&"
import script from "./PlatformAgreement.vue?vue&type=script&lang=js&"
export * from "./PlatformAgreement.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAgreement.vue?vue&type=style&index=0&id=4525cd70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4525cd70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4525cd70')) {
      api.createRecord('4525cd70', component.options)
    } else {
      api.reload('4525cd70', component.options)
    }
    module.hot.accept("./PlatformAgreement.vue?vue&type=template&id=4525cd70&scoped=true&", function () {
      api.rerender('4525cd70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/general/PlatformAgreement.vue"
export default component.exports